export default {
      id: "campaigns-usage",
      viewBox: "0 -5 32 32",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#campaigns",
      toString: function () {
        return this.url;
      }
    }